// extracted by mini-css-extract-plugin
module.exports = {"link":"LinkButton_link__9Bcfc"};